import React from "react";

function Error() {
  return <div className="container">Something went wrong</div>;
}

export default Error;
